import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { FileImage, FileAudio, FileText, Download, Loader2 } from "lucide-react";

const iconFor = (t) => (t.startsWith("image/") ? FileImage : t.startsWith("audio/") ? FileAudio : FileText);

export default function AttachmentList({ attachments }) {
  const [busy, setBusy] = useState(null);
  if (!attachments?.length) return null;

  const open = async (a) => {
    setBusy(a.id);
    try {
      const r = await api.get(`/gestor/attachments/${a.id}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div data-testid="attachment-list">
      <div className="text-xs uppercase tracking-widest text-slate-400 mb-2">Evidências anexadas ({attachments.length})</div>
      <ul className="grid sm:grid-cols-2 gap-2">
        {attachments.map((a) => {
          const Icon = iconFor(a.content_type || "");
          return (
            <li key={a.id}>
              <button type="button" onClick={() => open(a)} disabled={busy === a.id} data-testid="attachment-open-btn"
                className="w-full flex items-center gap-3 p-3 rounded-lg bg-slate-800 border border-slate-700 hover:border-teal-500/50 text-left text-sm transition-colors">
                <Icon className="w-4 h-4 text-teal-400 shrink-0" />
                <span className="text-slate-200 truncate flex-1">{a.filename}</span>
                {busy === a.id ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" /> : <Download className="w-4 h-4 text-slate-500" />}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
